<div class="cases" *ngIf="params.columnName!=='Notes' && params.columnName !== 'PoItemNote'">
    <div [ngClass]="{'cases-count' : params.isedit && (params.data.cases)}">{{params.data.cases | number : '1.2-2'}} </div>
</div>
  <div *ngIf="params.columnName === 'Notes' || params.columnName === 'PoItemNote'" [ngClass]="{' border-0' : !params.isedit}">
    <ng-container *ngIf="params.columnName === 'Notes'">
      <input *ngIf="params.isedit" [formControl]="notes" class="discount-price_input border-0" type="text" [(ngModel)]="params.data.notes">
      <div *ngIf="!params.isedit">{{ params.data.notes }}</div>
    </ng-container>
  
    <ng-container *ngIf="params.columnName === 'PoItemNote'">
      <input *ngIf="params.isedit" [formControl]="poItemNote" class="discount-price_input border-0" type="text" [(ngModel)]="params.data.poItemNote">
      <div *ngIf="!params.isedit">{{ params.data.poItemNote }}</div>
    </ng-container>
</div>
